<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailSociete.infoGeneral')}}
      </p>
    </header>
    <div class="card-content">
      <article class="media">
        <figure class="media-left">
          <app-logo readOnly
                    :elementId="societe.id"
                    :libelleElement="$t('detailSociete.libelleSocieteForLogo',
                    { libelle: societe.libelle })">
          </app-logo>
        </figure>
        <div class="media-content">
          <div class="content">
            <span class="has-text-default is-italic is-size-7">
              {{$t('detailSociete.infoSociete.codeSociete', { code: societe.codeSociete } )}}
            </span>
            <p class="title">{{societe.libelle}}</p>
            <span class="has-text-link">{{$t(getTypeSociete(societe.typeSociete))}}</span>
          </div>
        </div>
      </article>
      <div class="columns is-multiline">
        <div class="column is-2">
          <p class="has-text-link has-text-weight-bold mgb-20px">
            {{ $t('detailSociete.infoSociete.coordonnees') }}
          </p>
          <b-field :label="$t('detailSociete.infoSociete.telephone')"
                   custom-class="has-text-weight-normal is-italic is-marginless"
          >
            <span class="has-text-weight-bold">{{societe.telephone}}</span>
          </b-field>
        </div>
        <div class="column is-5">
          <p class="has-text-link has-text-weight-bold mgb-20px">
            {{ $t('detailSociete.infoSociete.infoAdministratives') }}
          </p>
          <div class="columns is-multiline">
            <div class="column is-6">
              <b-field :label="$t('detailSociete.infoSociete.siret')"
                       custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold">{{societe.siret}}</span>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('detailSociete.infoSociete.structureJuridique')"
                       custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold">{{societe.structureJuridique}}</span>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('detailSociete.infoSociete.ape')"
                       custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold">{{societe.codeAPE}}</span>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('detailSociete.infoSociete.tribunal')"
                       custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold">{{societe.tribunal}}</span>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('detailSociete.infoSociete.tvaIntracommunautaire')"
                       custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold">{{societe.tvaIntracommunautaire}}</span>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('detailSociete.infoSociete.numeroEmetteur')"
                       custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold">{{societe.numeroEmetteur}}</span>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('detailSociete.infoSociete.regimeTva')"
                       custom-class="has-text-weight-normal is-italic is-marginless">
                <span class="has-text-weight-bold">
                  {{getRegimeTvaLibelle(societe.regimeTvaId)}}
                </span>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('detailSociete.infoSociete.commentaireFactureIntracommunautaire')"
                       custom-class="has-text-weight-normal is-italic is-marginless">
                <div v-html="societe.commentaireFactureIntracommunautaire"
                     class="has-text-weight-bold">
                </div>
              </b-field>
            </div>
          </div>
        </div>
        <div class="column is-5">
          <p class="has-text-link has-text-weight-bold mgb-20px">
            {{ $t('detailSociete.infoSociete.adresse') }}
          </p>
          <b-field :label="$t('detailSociete.infoSociete.adresseDetail')"
                   custom-class="has-text-weight-normal is-italic is-marginless"
          >
            <span class="has-text-weight-bold">{{getAddress}}</span>
          </b-field>
          <b-field :label="$t('detailSociete.infoSociete.adresseLivraison')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">{{societe.adresseLivraison}}</span>
          </b-field>
          <b-field custom-class="has-text-weight-normal is-italic is-marginless"
            :label='$t("societes.signatureEmail")'>
            <div v-html="societe.emailSignature"></div>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import AppLogo from '@/components/general/Logo';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { LISTE_SOCIETES } from '@/configuration/societe/societe';
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      listeTypeSocietes: LISTE_SOCIETES,
    };
  },
  components: {
    AppLogo,
  },
  props: {
    societe: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametresWithoutFilterSocieteId',
    }),
    getAddress() {
      return adressFullStringGetter(this.societe.adresse);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getRegimeTvaLibelle(id) {
      return this.parametre(PARAMETRES_KEYS.regimeTva).find((tva) => {
        return tva.actif && tva.id === id;
      })?.libelle;
    },
    getTypeSociete(typeSociete) {
      return (this.listeTypeSocietes.find((liste) => {
        return typeSociete === liste.code;
      })).libelle;
    },
  },
  async mounted() {
    await this.loadParametres([PARAMETRES_KEYS.regimeTva]);
  },
};
</script>
